module.exports = __webpack_public_path__ + "img/product3.c4264a4f.jpg";